import { MEMBER_SCHEDULE } from "../apiConstant";
import BaseApi from "../baseApi";

class MemberScheduleApi extends BaseApi {
  update(param) {
    return this.post(`${MEMBER_SCHEDULE}/update`, param);
  }
}
export default MemberScheduleApi;
